export const GET_VERSION = 'GET_VERSION';
export const GET_VERSION_SUCCESS = 'GET_VERSION_SUCCESS';
export const GET_VERSION_ERROR = 'GET_VERSION_ERROR';
export const RESET_VERSION = 'RESET_VERSION';
